import React from "react";

const VerticalInputText = ({ onInputChange, defaultValue = "30", label = "secs" }) => {
  return (
    <div
      style={{
        fontSize: "50px",
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px", // Space between elements
      }}
    >
      <input
        className="input2"
        style={{
          fontSize: "40px",
          width: "1.7em",
          textAlign: "center", // Center the text in the input
        }}
        type="text"
        defaultValue={defaultValue}
        onBlur={(e) => onInputChange(e.target.value)}
        onSubmit={(e) => {
            onInputChange(e.target.value)
            document.activeElement.blur()
        }}
        
      />
      <span style={{ fontSize: "20px" }}>{label}</span>
    </div>
  );
};

export default VerticalInputText;
